<template>
  <v-autocomplete
      :value="value"
      :label="label"
      :prepend-inner-icon="icon"
      :items="items"
      :loading="loading"
      :search-input.sync="search"
      :item-text="itemText"
      :menu-props="menuProps"
      no-filter
      return-object
      hide-details
      clearable
      dense
      class="text-caption"
      @change="onSelect"
      @click:clear="onClear"
      @click.stop
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>
          <span class="font-weight-bold">{{ item.locode }}</span>
          · {{ item.countryName }}
        </v-list-item-title>
        <v-list-item-subtitle>{{ item.countryId }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { nodiService } from '@/services/nodi.service'

export default {
  name: 'NodoAutocomplete',
  props: {
    value: { type: Object, default: null },
    label: { type: String, required: true },
    icon:  { type: String, default: 'mdi-map-marker' },
  },
  emits: ['input', 'change'],
  data() {
    return {
      search:   null,
      items:    [],
      loading:  false,
      debounce: null,
      menuProps: { offsetY: true, maxHeight: '10rem' },
    }
  },
  computed: {
    itemText() {
      return (n) => `${n.locode} ${n.countryName}`
    },
  },
  watch: {
    search(val) {
      if (!val || val.length < 2) return
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.loading = true
        nodiService.searchNodi(val)
            .then(resp => { this.items = resp })
            .finally(() => { this.loading = false })
      }, 300)
    },
  },
  methods: {
    onSelect(nodo) {
      this.$emit('input', nodo)
      this.$emit('change', nodo)
    },
    onClear() {
      this.items = []
      this.$emit('input', null)
      this.$emit('change', null)
    },
    clearSelection() {
      this.items  = []
      this.search = null
      this.$emit('input', null)
      this.$emit('change', null)
    },
  },
}
</script>